import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { FormFieldModel } from './form-field.model';
import { DisplayElementModel } from './display-element.model';

export class ConditionalTextHeadingFieldModel implements FormFieldModel {
    property = ''; // there's no relevant property - 'null' throws errors.

    fieldComponent: Type<AbstractFormFieldComponent>;
    heading: string;
    id: string;
    displayCondition: () => boolean;

    constructor(type: Type<AbstractFormFieldComponent>, heading: string, id: string = '', displayCondition) {
        this.fieldComponent = type;
        this.heading = heading;
        this.id = id;
        this.displayCondition = displayCondition;
    }
}
